import { Col, Form, Row } from "react-bootstrap";
import TableFilterBox from "../organisms/TableFilterBox";
import TableHeader from "../organisms/TableHeader";
import TableFooter from "../organisms/TableFooter";
import styled from "styled-components";
import DataTable from "./DataTable";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useEffect, useRef, useState } from "react";
import { useQuery } from "@tanstack/react-query";
import TablePagination from "../molecules/TablePagination";
import axios from "axios";
import SelectBox from "../molecules/SelectBox";
import { useSelector } from "react-redux";
import AccessDenied from "../pages/AuthPage/AccessDenied";
import { useMasking } from "../../common/hook";

const TableWrap = styled.div`
    flex: 1 1;
    display: flex;
    flex-direction: column;

    .data-table {
        flex-grow: 1;
    }
`;

export default function ChiefAdmin() {
    const perPageOptions = useSelector(state => state.perPageOptions);
    const loginInfo = useSelector(state => state.login);
    const location = useLocation();
    const navigate = useNavigate();

    const defaultFilter = {
        orderField: "register_time",
        order: "desc",
        page: 1,
        perPage: 10,
        name: "",
        phone: ""
    }
    const [tableData, setTableData] = useState({
        orderField: ['position', 'name', 'phone', 'resiterTime', 'lastLoginTile'],
        head: ["직책", "이름", "휴대폰번호", "등록일시", "최근 접속일시"],
        body: [
            [],
        ],
    });
    const [dataTotal, setDataTotal] = useState(0);
    const [filter, setFilter] = useState(localStorage.getItem("digilog_aFilter") ? JSON.parse(localStorage.getItem("digilog_aFilter")) : defaultFilter);

    const filterNameRef = useRef();
    const filterPhoneRef = useRef();

    const {masking} = useMasking();

    
    const {data, isError, isLoading, refetch, isRefetching} = useQuery({
        queryKey: ['adminList'],
        queryFn: () => axios("/admin/list", {
            method: "POST",
            data: filter
        }).then(result => {
            if (result.data.code == "0") {
                const arr = [];
                result.data.data.list.forEach((el, idx) => {
                    arr.push(
                        [
                            el.position,
                            <Link onClick={() => {
                                localStorage.setItem("digilog_aFilter", JSON.stringify(filter));
                            }} to={"/admin/detail/chief/" + el.adminId}>{masking(el.name)}</Link>,
                            masking(el.phone, "phone"),
                            el.registerTime,
                            el.lastLoginTime,
                        ]
                    );
                });
                setTableData({
                    ...tableData,
                    total: result.data.data.total,
                    body: arr
                });
                setDataTotal(result.data.data.total);
            } else {
                throw new Error(result.data.msg.ko);
            }
            
            return result;
        }),
        enabled: false
    });

    useEffect(() => {
        refetch();
    },[filter]);

    useEffect(() => {
        if (loginInfo.admin.level) {
            if (loginInfo.admin.level > 1) {
                navigate("/error/accessDenied")
            }
        }
    },[loginInfo]);

    useEffect(() => {
        refetch();
    },[location]);


    useEffect(() => {
        localStorage.removeItem("digilog_aFilter");
    },[]);

    return (
        <>
            <TableFilterBox 
                handleClickSubmit={() => {
                    setFilter({
                        ...filter,
                        page: 1,
                        name: filterNameRef.current.value,
                        phone: filterPhoneRef.current.value
                    })
                }}
                handleClickReset={() => {
                    filterNameRef.current.value = "";
                    filterPhoneRef.current.value = "";
                    setFilter({
                        ...filter,
                        ...defaultFilter
                    })
                }}
            >
                <Row className="justify-content-between">
                    <Col sm={6} xxl={5}>
                        <Form.Group as={Row}>
                            <Form.Label column sm={2} xxl={3}>
                                이름
                            </Form.Label>
                            <Col sm={10} xxl={9}>
                                <Form.Control ref={filterNameRef} defaultValue={filter.name} type="text" placeholder="이름을 입력하세요." />
                            </Col>
                        </Form.Group>
                    </Col>

                    <Col sm={6} xxl={5}>
                        <Form.Group as={Row}>
                            <Form.Label column sm={2} xxl={3}>
                                휴대폰번호
                            </Form.Label>
                            <Col sm={10} xxl={9}>
                                <Form.Control ref={filterPhoneRef} defaultValue={filter.phone} type="text" placeholder="휴대폰 번호를 입력하세요." />
                            </Col>
                        </Form.Group>
                    </Col>
                </Row>
            </TableFilterBox>

            <TableWrap className="mt-4">
                <TableHeader total={dataTotal}>
                    <div style={{width: "200px"}}>
                        <SelectBox
                            onChange={(value) => {
                                setFilter({
                                    ...filter,
                                    page: 1,
                                    perPage: value.value
                                })
                            }} 
                            className="w-auto"
                            defaultValue={filter.perPage}
                            data={perPageOptions}
                        />
                    </div>
                    <TableHeader.ButtonBox>
                        <Link to="/admin/add/chief/" className="btn btn-primary">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                                <path d="M1 14s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1zm5-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6"/>
                                <path fillRule="evenodd" d="M13.5 5a.5.5 0 0 1 .5.5V7h1.5a.5.5 0 0 1 0 1H14v1.5a.5.5 0 0 1-1 0V8h-1.5a.5.5 0 0 1 0-1H13V5.5a.5.5 0 0 1 .5-.5"/>
                            </svg>
                            관리자 등록
                        </Link>
                    </TableHeader.ButtonBox>
                </TableHeader>

                <DataTable isError={isError} isLoading={isLoading || isRefetching} data={tableData} 
                            useNo={true}
                            sort={[4]} activeSortIdx={4}  handleClickSort={(idx, type) => {
                                setFilter({
                                    ...filter,
                                    orderField: tableData.orderField[idx],
                                    order: type,
                                })
                            }} />

                <TableFooter>
                    <TablePagination total={dataTotal} perPage={filter.perPage} currentPage={filter.page}
                    onChange={(value) => {
                        setFilter({
                            ...filter,
                            page: value
                        })
                    }} />
                </TableFooter>
            </TableWrap>
        </>
    );
}
